import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import AttributeAdditionalService from "../../Services/AttributeAdditionalService";

export const AttributeAdditionalFees = () => {
  const [loader, setLoader] = useState(true);
  const [fieldarr, setFieldarr] = useState([]);

  const getData = async () => {
    setLoader(true);
    const res = await AttributeAdditionalService.getAttributeadditionalfees();
    if (res?.data) {
      setFieldarr(res.data);
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Flatten initial values from API data
  const initialValues = {
    items:
      fieldarr &&
      fieldarr.flatMap((item) =>
        item.data.map((shipment) => ({
          attr_name: item.attribute_name,
          shipment_type: shipment.shipment_type,
          charges: {
            dg_declaration: shipment.dg_declaration || 0,
            dangerous_goods_fee: shipment.dangerous_goods_fee || 0,
            dg_packing: shipment.dg_packing || 0,
            airline_handling: shipment.airline_handling || 0,
          },
        }))
      ),
  };

  const validationSchema = Yup.object().shape({
    items: Yup.array().of(
      Yup.object().shape({
        charges: Yup.object().shape({
          dg_declaration: Yup.number().required("Required"),
          dangerous_goods_fee: Yup.number().required("Required"),
          dg_packing: Yup.number().required("Required"),
          airline_handling: Yup.number().required("Required"),
        }),
      })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const formattedData =
        fieldarr &&
        fieldarr.map((item) => ({
          attribute_name: item.attribute_name,
          data: values.items
            .filter((shipment) => shipment.attr_name === item.attribute_name)
            .map((shipment) => ({
              shipment_type: shipment.shipment_type,
              ...shipment.charges,
            })),
        }));

      setLoader(true);
      AttributeAdditionalService.addAttributeadditionalfees({
        data: formattedData,
      })
        .then((res) => {
          if (res.status) {
            toast.success(res.msg);
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error) => {
          toast.error("Failed to submit.");
        })
        .finally(() => setLoader(false));
    },
  });

  console.log(fieldarr, "fieldarr");

  return (
    <div>
      {(loader && <Loader isShow={loader} />) || (
        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex mt-3 justify-content-end">
            <button
              className="btn btn-primary mb-4"
              type="submit"
              disabled={loader}
              style={{ marginTop: "-55px", zIndex: "1" }}
            >
              {loader ? "Updating..." : "Update"}
            </button>
          </div>
          {fieldarr &&
            fieldarr.map((item, attrIndex) => (
              <div className="card">
                <div className="card-header">
                  <h5 className="mb-0">{item.attribute_name.toUpperCase()}</h5>
                </div>
                <div className="card-body">
                  <div key={item.attribute_name} className="mb-2 row">
                    {item.data.map((shipment, shipIndex) => {
                      console.log(shipment.shipment_type, "shipment");
                      const fieldIndex =
                        attrIndex * item.data.length + shipIndex;
                      const fieldPath = `items[${fieldIndex}].charges`;

                      return (
                        <div key={shipment.shipment_type} className=" col-sm-3">
                          <fieldset
                            style={{
                              border: "1px solid #d4d4d4",
                              padding: "15px",
                              borderRadius: "5px",
                              marginTop: "5px",
                            }}
                          >
                            <h6
                              style={{
                                marginTop: "-23px",
                                backgroundColor: "white",
                                width: "fit-content",
                                padding: "0 5px",
                                marginBottom: "10px",
                              }}
                            >
                              {shipment.shipment_type}
                            </h6>
                            {/* {Object.keys(initialValues.items[0].charges).map(
                              (key) => (
                                  <>
                              {console.log(key, "key")}
                                    <label className="form-label">
                                      {item.attribute_name === "battery" && key === "dg_declaration" ? "ELI/ ELM Fee"
                                        : item.attribute_name === "magnet" && key === "dg_declaration" ? "MAF Fee"
                                        : key === "airline_handling" ? key.replace(/_/g, " ").toUpperCase() + " (per Kg)"
                                        : key.replace(/_/g, " ").toUpperCase()}
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control mb-2 ${
                                        formik.touched.items?.[fieldIndex]
                                          ?.charges?.[key] &&
                                        formik.errors.items?.[fieldIndex]
                                          ?.charges?.[key]
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name={`${fieldPath}.${key}`}
                                      value={
                                        formik.values.items[fieldIndex]
                                          ?.charges[key]
                                      }
                                      onChange={formik.handleChange}
                                    />
                                    {formik.touched.items?.[fieldIndex]
                                      ?.charges?.[key] &&
                                      formik.errors.items?.[fieldIndex]
                                        ?.charges?.[key] && (
                                        <div className="text-danger">
                                          {
                                            formik.errors.items[fieldIndex]
                                              .charges[key]
                                          }
                                        </div>
                                      )}
                                  </>
                              )
                            )} */}
                            {Object.keys(initialValues.items[0].charges).map(
                              (key) => {
                                const shouldHide =
                                  ["SEA", "LAND"].includes(
                                    shipment.shipment_type?.toUpperCase()
                                  ) && key === "airline_handling";

                                if (shouldHide) return null;

                                return (
                                  <React.Fragment key={key}>
                                    <label className="form-label">
                                      {item.attribute_name === "battery" &&
                                      key === "dg_declaration"
                                        ? "ELI/ ELM Fee"
                                        : item.attribute_name === "magnet" &&
                                          key === "dg_declaration"
                                        ? "MAF Fee"
                                        : key === "airline_handling"
                                        ? key.replace(/_/g, " ").toUpperCase() +
                                          " (per Kg)"
                                        : key.replace(/_/g, " ").toUpperCase()}
                                    </label>
                                    <input
                                      type="number"
                                      className={`form-control mb-2 ${
                                        formik.touched.items?.[fieldIndex]
                                          ?.charges?.[key] &&
                                        formik.errors.items?.[fieldIndex]
                                          ?.charges?.[key]
                                          ? "is-invalid"
                                          : ""
                                      }`}
                                      name={`${fieldPath}.${key}`}
                                      value={
                                        formik.values.items[fieldIndex]
                                          ?.charges[key]
                                      }
                                      onChange={formik.handleChange}
                                    />
                                    {formik.touched.items?.[fieldIndex]
                                      ?.charges?.[key] &&
                                      formik.errors.items?.[fieldIndex]
                                        ?.charges?.[key] && (
                                        <div className="text-danger">
                                          {
                                            formik.errors.items[fieldIndex]
                                              .charges[key]
                                          }
                                        </div>
                                      )}
                                  </React.Fragment>
                                );
                              }
                            )}
                          </fieldset>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ))}
        </form>
      )}
      {loader && <Loader isShow={loader} />}
    </div>
  );
};

export default AttributeAdditionalFees;
